module.exports = __webpack_public_path__ + "static/img/trophy.6110360.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/icons/trophy.png
// module id = 6KL1
// module chunks = 2